import { render, staticRenderFns } from "./AjaxSelectMulti.vue?vue&type=template&id=50d884d4&scoped=true"
import script from "./AjaxSelectMulti.vue?vue&type=script&lang=js"
export * from "./AjaxSelectMulti.vue?vue&type=script&lang=js"
import style0 from "./AjaxSelectMulti.vue?vue&type=style&index=0&id=50d884d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d884d4",
  null
  
)

export default component.exports